import DevelperTeamPage from "@/pages/blue-hoster/developer-team"
import HosterListPage from "@/pages/blue-hoster/hoster-list"
import HosterDetailPage from "@/pages/blue-hoster/hoster-detail"
import starClubListPage from "@/pages/blue-hoster/star-club/index"
import companyInfoPage from "@/pages/blue-hoster/company-info"

// 广告列表
export const develperTeam = {
  path: 'blue-hoster/developer-team',
  component: DevelperTeamPage
}

export const hosterList = {
  path: 'blue-hoster/hoster-list',
  component: HosterListPage
}

export const hosterDetail = {
  path: 'blue-hoster/hoster-detail',
  component: HosterDetailPage
}

//星创俱乐部
export const starClubList = {
  path: 'blueHost/starClub',
  component: starClubListPage
}
//公司代理管理
export const companyInfo = {
  path: 'blueHost/companyInfo',
  component: companyInfoPage
}


// WEBPACK FOOTER //
// ./src/router/blue-hoster.js